import { useSearch, useNavigate } from "@tanstack/react-router";
import type { DateRange, RecentPeriod } from "../../types/date";
import { resolveDateRange, toIsoDateString } from "../../utils/searchParams";
import type { DateRangeSearchParams } from "../../utils/searchParams";
import { DateRangePicker } from "../DateRangePicker/DateRangePicker";

export const OverviewDateRangePicker = () => {
  const { startDate: startDateStr, endDate: endDateStr, quickSelect } = useSearch({ strict: false }) as DateRangeSearchParams;
  const { startDate, endDate } = resolveDateRange({ startDate: startDateStr, endDate: endDateStr, quickSelect });
  const navigate = useNavigate();

  const handleSubmit = ({ startDate, endDate }: DateRange, qs?: RecentPeriod) => {
    navigate({
      to: "/overview",
      search: (prev) => ({
        ...prev,
        quickSelect: qs,
        startDate: qs ? undefined : toIsoDateString(startDate),
        endDate: qs ? undefined : toIsoDateString(endDate),
      }),
    });
  };

  return <DateRangePicker dateRange={{ startDate, endDate }} quickSelect={quickSelect} onSubmit={handleSubmit} />;
};
